const generateWinkelServiceLink = (node: any, namespace: "winkel" | "service") => {
  if (node.frontmatter.override_link) return node.frontmatter.override_link
  if (node.frontmatter.is_active) return `/${namespace}/${node.fields.slug}`
  return "/binnenkort?goBack=true"
}

export default generateWinkelServiceLink
